import { ITEMS_LIST_URL } from '../util/urls';
import { API_ERROR, GetOrderType } from '../lib/helper.js';
import { filterItem } from '../views/menu/actions';
import { map, orderBy } from 'lodash';

//Action Types
export const LOAD_ITEMS = 'LOAD_ITEMS';

//Actions
/*export const loadMenuItems = (
  subMenuItemClicked,
  mainMenuItemClicked,
  modeOfOrder,
  tokenId,
  jwt,
  dataName,
  onStartLoad,
  menuArrayItems
) => {
  return dispatch => {
    if (!subMenuItemClicked) {
      return new Promise(resolve => {
        resolve({});
      });
    }

    return new Promise(resolve => {
      const orderMode = onStartLoad || modeOfOrder;
      const modeOfOrderStr = GetOrderType(orderMode, false, true);
      fetch(
        ITEMS_LIST_URL +
          'tokenId/' +
          tokenId +
          '/dataname/' +
          dataName +
          '/current_page/1/per_page/8/category_id/' +
          subMenuItemClicked +
          '/dining_option/' +
          modeOfOrderStr,
        {
          method: 'GET',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Basic ' + btoa(jwt),
          },
        }
      )
        .catch(error => {
          API_ERROR(error, ITEMS_LIST_URL);
        })
        .then(res => (res ? res.json() : []))
        .then(data => {
          let menuItemArray = [];
          let bannerImage = data.DataResponse.bannerImage;
          if (!data.DataResponse.Items) {
            return [];
          }
          let items = data.DataResponse.Items;
          if (items !== null)
            items.forEach((item, index) => {
              items[index] = filterItem({
                item,
                isForcedIdSet:
                  item.forced[0] && item.forced[0].id ? true : false,
              });
            });
          menuArrayItems.map(menuItem => {
            if (menuItem.id === mainMenuItemClicked) {
              menuItem.mainMenuItem.map(subMenuItem => {
                if (subMenuItem.id === subMenuItemClicked) {
                  subMenuItem['menuItems'] = items;
                }
              });
            }
          });
          menuItemArray.push(Object.assign({ [subMenuItemClicked]: items }));
          dispatch({
            type: LOAD_ITEMS,
            items: menuItemArray,
            menuArray: menuArrayItems,
            bannerImage: bannerImage,
            pagination: data.DataResponse.pagination,
          });
          resolve();
        });
    });
  };
};*/

export const loadMenuItems = (
  subMenuItemClicked,
  modeOfOrder,
  tokenId,
  jwt,
  dataName,
  onStartLoad
) => {
  return dispatch => {
    if (!subMenuItemClicked) {
      return new Promise(resolve => {
        resolve({});
      });
    }

    return new Promise(resolve => {
      const orderMode = onStartLoad || modeOfOrder;
      const modeOfOrderStr = GetOrderType(orderMode, false, true);
      fetch(
        ITEMS_LIST_URL +
          'tokenId/' +
          tokenId +
          '/dataname/' +
          dataName +
          '/current_page/1/per_page/8/category_id/' +
          subMenuItemClicked +
          '/dining_option/' +
          modeOfOrderStr,
        {
          method: 'GET',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Basic ' + btoa(jwt),
          },
        }
      )
        .catch(error => {
          API_ERROR(error, ITEMS_LIST_URL);
        })
        .then(res => (res ? res.json() : []))
        .then(data => {
          let bannerImage = data.DataResponse.bannerImage;
          if (!data.DataResponse.Items) {
            return [];
          }
          let items = data.DataResponse.Items;
          if (items !== null)
            items.forEach((item, index) => {
              items[index] = filterItem({
                item,
                isForcedIdSet:
                  item.forced[0] && item.forced[0].id ? true : false,
              });
            });
          dispatch({
            type: LOAD_ITEMS,
            items: items,
            bannerImage: bannerImage,
            pagination: data.DataResponse.pagination,
          });
          resolve();
        });
    });
  };
};

/*export const loadMenuItems = (
  subMenuItemClicked,
  mainMenuItemClicked,
  modeOfOrder,
  tokenId,
  jwt,
  dataName,
  onStartLoad,
  menuArrayItems
) => {
  return dispatch => {
    if (!subMenuItemClicked) {
      return new Promise(resolve => {
        resolve({});
      });
    }

    var sortedArray = new Promise(function(resolve, reject) {
      map(menuArrayItems, function(menuData, index) {
        menuData.mainMenuItem =
          menuData.orderby === 'alpha' || menuData.orderby === '' || menuData.orderby === 0
            ? orderBy(menuData.mainMenuItem, 'text', 'asc')
            : orderBy(menuData.mainMenuItem, 'id', 'asc');
        if (index === menuArrayItems.length - 1) resolve(menuArrayItems);
      });
    });
    return sortedArray.then(function(sortedItems) {
      return new Promise(resolve => {
        const orderMode = onStartLoad || modeOfOrder;
        const modeOfOrderStr = GetOrderType(orderMode, false, true);

        sortedItems.map((menuItem, indexVal) => {
          // if (menuItem.id === mainMenuItemClicked) {
          menuItem.mainMenuItem.map(async function(subMenuItem) {
            if (subMenuItem.parentid === mainMenuItemClicked) {
              fetch(
                ITEMS_LIST_URL +
                  'tokenId/' +
                  tokenId +
                  '/dataname/' +
                  dataName +
                  '/current_page/1/per_page/8/category_id/' +
                  subMenuItem.id +
                  '/dining_option/' +
                  modeOfOrderStr,
                {
                  method: 'GET',
                  headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: 'Basic ' + btoa(jwt),
                  },
                }
              )
                .catch(error => {
                  API_ERROR(error, ITEMS_LIST_URL);
                })
                .then(res => (res ? res.json() : []))
                .then(data => {
                  let menuItemArray = [];
                  let bannerImage = data.DataResponse.bannerImage;
                  if (!data.DataResponse.Items) {
                    return [];
                  }
                  let items = data.DataResponse.Items;
                  if (items !== null)
                    items.forEach((item, index) => {
                      items[index] = filterItem({
                        item,
                        isForcedIdSet:
                          item.forced[0] && item.forced[0].id ? true : false,
                      });
                    });
                  subMenuItem['menuItems'] = items;
                  menuItemArray.push(
                    Object.assign({ [subMenuItemClicked]: items })
                  );
                  // if (indexVal === sortedItems.length - 1) {
                  dispatch({
                    type: LOAD_ITEMS,
                    items: menuItemArray,
                    menuArray: sortedItems,
                    bannerImage: bannerImage,
                    pagination: data.DataResponse.pagination,
                  });
                  resolve();
                  //}
                });
            }
          });
          // }
        });
      });
    });
  };
};*/



// WEBPACK FOOTER //
// ./src/actions/MenuItemsActions.js